import { useState, useEffect } from 'react';
import ReactPaginate from 'react-paginate';
import { useSearchZustandStore } from '@/helpers/searchctx.js';
import Icon from '@/core/icon.js';
import { lang } from '@/helpers/translate';
// import { getRootUrl } from '@/helpers/router.js';
// import { isClient as hpIsClient } from '@/helpers/common';

function Paginator({ resume }) {
  // const [isClient, setIsClient] = useState(!hpIsClient());
  const langCurrent = lang();
  const { initParams } = useSearchZustandStore.getState();
  const byPage = 24; const
    { spacesTotal } = resume || {};
  const nbTotalPages = Math.ceil((spacesTotal || 0) / byPage);
  const [currentData, setCurrentData] = useState({ isChange: null, page: initParams.page });

  const items = [];
  for (let i = 1; i <= nbTotalPages; i += 1) {
    items.push(i);
  }

  useEffect(() => {
    if (currentData.isChange) {
      useSearchZustandStore.setState({ currentPage: currentData.page, searchEvent: { action: 'paginatorcallsearch' } });
    }
  }, [currentData.isChange]);

  const handlePageClick = (e) => {
    setCurrentData({ isChange: new Date(), page: e.selected + 1 });
  };

  return (
    <div className="flex items-center justify-center pt-5 border-t border-white-dark2 text-purple-5/50 mb-36 lg:mb-10">
      <ReactPaginate
        className="flex items-center justify-center mx-2 space-x-2 md:space-x-3"
        breakLabel="···"
        forcePage={(currentData.page - 1) || 0}
        nextLabel={<span className="flex items-center justify-center w-8 h-8 transition rounded-lg hover:bg-purple-0 hover:text-white group"><Icon className="w-5 h-5 text-purple-5/50 group-hover:text-black" name="next" /></span>}
        onPageChange={handlePageClick}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        hrefBuilder={(page, pageCount, selected) => (page >= 1 && page <= pageCount ? `${initParams?.hub}?page=${page}` : '#')
        }
        hrefAllControls
        pageCount={nbTotalPages}
        previousLabel={<span className="flex items-center justify-center w-8 h-8 transition rounded-lg hover:bg-purple-0 hover:text-white group"><Icon className="w-5 h-5 transform rotate-180 group-hover:text-black" name="next" /></span>}
        renderOnZeroPageCount={null}
        activeClassName="flex items-center justify-center block bg-black text-white w-8 h-8"
        pageLinkClassName="rounded-lg transition block w-full h-full text-center align-middle pt-1 hover:text-black"
        activeLinkClassName="hover:text-white hover:bg-black cursor-default"
        disabledLinkClassName="invisible"
        pageClassName="transition flex items-center justify-center w-8 h-8 block rounded-lg group"
      />
    </div>

  );
  // return (
  //   <div className="flex justify-center pt-5 mb-10 space-x-1 border-t border-white-dark2">
  //     {Array(nbTotalPages).fill(1).map((v,p)=>{
  //       let newp = p + 1
  //       return (<div className={`transition flex items-center justify-center text-sm
  //  rounded-full cursor-pointer w-9 h-9 hover:bg-purple-0 hover:
  // ${newp !== currentData.page || `'  bg-purple/10 text-purple' }`}
  // key={`searchresultspaginator${newp}`} onClick={()=>gotoPage(newp)}><span>{newp}</span></div>)
  //     })}
  //   </div>
  // )
}

export default Paginator;
